export default __webpack_public_path__ + "static/media/spin.8c4c3c28.svg";